import { Tag } from '@/shared/model/tag.model';
import DataService from '@/core/base/service/data.service';

export default class TagService extends DataService<Tag> {
    baseApiUrl = 'api/tags';
}
